import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  EllipsisOutlined,
} from '@ant-design/icons';
import { colorTokens, semanticColors } from '@revenuemarket/design';
import { Badge } from 'antd';

import { WIRING_RESULT_STATUS, WiringType } from '~apis/wiring';

export const getDataForFilter = (filter: WIRING_RESULT_STATUS | '') => {
  switch (filter) {
    case 'REGISTERED':
      return {
        icon: ({ color }: { color: string }) => (
          <EllipsisOutlined
            style={{
              fontSize: 16,
              color,
            }}
          />
        ),
        title: '작성 완료',
        color: colorTokens.textDescription,
      };
    case 'PROCESSING':
      return {
        icon: ({ color }: { color: string }) => (
          <ClockCircleOutlined
            style={{
              fontSize: 16,
              color,
            }}
          />
        ),
        title: '이체 대기·예약 ',
        color: '#FAAD14',
      };
    case 'SUCCESS':
      return {
        icon: ({ color }: { color: string }) => (
          <CheckCircleOutlined
            style={{
              color,
              fontSize: 16,
            }}
          />
        ),
        title: '이체 완료',
        color: semanticColors.success.medium,
      };
    case 'PARTIAL_FAILED':
      return {
        icon: ({ color }: { color: string }) => (
          <CloseCircleOutlined
            style={{
              color,
              fontSize: 16,
            }}
          />
        ),
        title: '부분 실패',
        color: semanticColors.danger.medium,
      };
    case 'FAILED':
      return {
        icon: ({ color }: { color: string }) => (
          <CloseCircleOutlined
            style={{
              color,
              fontSize: 16,
            }}
          />
        ),
        title: '전체 실패',
        color: semanticColors.danger.medium,
      };
    default:
      return {
        title: '전체',
        icon: () => <div />,
        color: colorTokens.textDescription,
      };
  }
};

export const wiringStatusRender = (status: WIRING_RESULT_STATUS) => {
  switch (status) {
    case 'SUCCESS':
      return <Badge status="success" text={getDataForFilter('SUCCESS').title} />;
    case 'PROCESSING':
      return <Badge status="warning" text={getDataForFilter('PROCESSING').title} />;
    case 'PARTIAL_FAILED':
      return <Badge status="error" text={getDataForFilter('PARTIAL_FAILED').title} />;
    case 'FAILED':
      return <Badge status="error" text={getDataForFilter('FAILED').title} />;
    case 'REGISTERED':
      return <Badge status="default" text={getDataForFilter('REGISTERED').title} />;
  }
};

export const wiringTypeRender = (type: WiringType) => {
  switch (type) {
    case 'NORMAL':
      return '즉시이체';
    case 'SALARY':
      return '급여이체';
  }
};
